import * as bootstrap from './bs/index.js';
window.bootstrap = bootstrap;
// import './lib/masonry.pkgd.min.js'
// import './lib/imagesloaded.pkgd.min.js'

// import './i/accessibility.js'
import './i/color-modes.js'
import './i/django.js'
import './i/form.js'
import './i/modal.js'
import './i/search.js'
import './i/formset.js'
import './i/i.js'
